import React from 'react'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, id, style, ...props }, ref) => {
    const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-')
    const [focused, setFocused] = React.useState(false)

    return (
      <div style={{ width: '100%' }}>
        {label && (
          <label
            htmlFor={inputId}
            style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#64748b', marginBottom: 6 }}
          >
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          {...props}
          onFocus={(e) => { setFocused(true); props.onFocus?.(e) }}
          onBlur={(e) => { setFocused(false); props.onBlur?.(e) }}
          style={{
            display: 'block',
            width: '100%',
            height: 36,
            padding: '0 10px',
            borderRadius: 7,
            border: `1px solid ${error ? '#dc2626' : focused ? '#4f46e5' : '#e8ecf4'}`,
            fontSize: 13,
            color: '#0f172a',
            background: props.disabled ? '#f8fafc' : '#ffffff',
            outline: 'none',
            boxShadow: focused ? `0 0 0 3px ${error ? '#fee2e2' : '#eef2ff'}` : 'none',
            transition: 'border-color 0.15s, box-shadow 0.15s',
            fontFamily: 'inherit',
            boxSizing: 'border-box',
            ...style,
          }}
        />
        {error && (
          <p style={{ fontSize: 11, color: '#dc2626', marginTop: 4 }}>{error}</p>
        )}
      </div>
    )
  },
)
Input.displayName = 'Input'
